import { Injectable } from '@angular/core';
import { BrowserInfoData } from 'src/app/shared/models/user/browserInfo';

@Injectable({
  providedIn: 'root',
})
export class BrowserInfoService {
  constructor() {}

  getFingerprint(): BrowserInfoData {
    const userAgent = this.getUserAgent();
    const { vendor, renderer } = this.getWebGLInfo();
    return { userAgent, vendor, renderer };
  }

  private getUserAgent(): string {
    return navigator.userAgent;
  }

  private getWebGLInfo(): Partial<BrowserInfoData> {
    try {
      const canvas = document.createElement('canvas');
      const gl = canvas.getContext('webgl') as WebGLRenderingContext | null;

      if (!gl) {
        return { vendor: null, renderer: null };
      }

      const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
      const vendor = debugInfo ? gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL) : 'unknown';
      const renderer = debugInfo ? gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) : 'unknown';

      return { vendor, renderer };
    } catch (e) {
      return { vendor: null, renderer: null };
    }
  }
}
